import {isUndefined} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {TeamAvatar} from '../../../components/common/avatars/teamAvatar';
import {useAppSelector} from '../../../helpers/reduxHelpers';
import {getTeams} from '../../../store/data/teams/teamsSelectors';
import {StyledFlex} from '../../components/reportViewer/reportCommons';
import {MetricTeamRenderer} from '../analyticsFormatHelpers';

/*
 * Styles.
 */

const StyledAvatar = styled(TeamAvatar)`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-right: 4px;
`;

const StyledTeamsName = styled.div`
  ${ellipsis()}
`;

/*
 * Formatter.
 */

const TeamValue: FC<{teamId?: number; fallback?: string}> = ({teamId, fallback}) => {
  const allTeams = useAppSelector(getTeams);
  const renderFallback = !isUndefined(fallback) ? <>{fallback}</> : <>-</>;

  if (isUndefined(teamId)) {
    return renderFallback;
  }

  const team = allTeams[teamId];

  if (!team) {
    return renderFallback;
  }

  return (
    <StyledFlex>
      <StyledAvatar team={team} size={VisualSizesEnum.MEDIUM} />
      <StyledTeamsName>{team.name}</StyledTeamsName>
    </StyledFlex>
  );
};

export const renderTeamValue: MetricTeamRenderer = ({id, value}) => (
  <TeamValue teamId={id} fallback={value} />
);
